/**
 * Normalize comma thousands separators inside numeric labels. Only commas
 * between digits are removed, so arbitrary comma-containing text stays text.
 */
export function normalizeThousandsSeparators(value: string): string {
  return value.replace(/(\d),(\d)/g, '$1$2');
}

/**
 * `Number.isFinite` narrows nothing — it is typed `(number: unknown) => boolean`, so a guarded value stays
 * `unknown` and every use needs an `as number` the compiler can never re-check against the guard. This is
 * the predicate form: same runtime rule (rejects NaN, ±Infinity, and non-numbers), but the type follows.
 */
export function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}
